import { render } from "./main-page.vue?vue&type=template&id=cf1a37dc&scoped=true&ts=true"
import script from "./main-page.vue?vue&type=script&lang=ts"
export * from "./main-page.vue?vue&type=script&lang=ts"

import "./main-page.vue?vue&type=style&index=0&id=cf1a37dc&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf1a37dc"]])

export default __exports__